/**
 * useUser  thin wrapper re-exporting everything from UserContext.
 *
 * UserContext.tsx contains the actual enrichment logic (single Provider instance).
 * This file exists only for backward-compatibility: all callers of
 * `import { useUser } from "/hooks/useUser"` continue working unchanged.
 */
export {
  setPreferredUserType,
  clearPreferredUserType,
  notifyAuthChange,
  resetGlobalEnrichGuard,
  AUTH_EVENT,
} from '../context/UserContext';

export type { UserContextType as UseUserReturn } from '../context/UserContext';

import { useUserContext } from '../context/UserContext';

interface UseUserOptions {
  /** @deprecated — ignored, no caller uses preferMock=true */
  preferMock?: boolean;
}

/** Returns user state from UserContext. The options param is kept for backward compat but ignored. */
export function useUser(_options: UseUserOptions = {}) {
  return useUserContext();
}
